export default __webpack_public_path__ + "static/media/feature-icon-1.15c72e7d.svg";